import styled, { css } from 'styled-components';

import ToggleButton from '../ToggleButton';

export const StyledToggleButtonList = styled.div<{
  fullWidth?: boolean;
  isSwitch?: boolean;
  isChips?: boolean;
}>`
  ${({ fullWidth }) => fullWidth && css`
    ${ToggleButton.StyledLabel} {
      flex-grow: 1;
      box-sizing: border-box;
    }
  `}
  margin-bottom: -12px;
  ${({ isSwitch, isChips }) => !isSwitch && !isChips && css`
    ${ToggleButton.StyledLabel} {
      margin-right: 12px;
      margin-bottom: 12px;
    }
  `}
  
  ${({ isChips }) => isChips && css`
    margin-bottom: -8px;
  
    ${ToggleButton.StyledLabel} {
      margin-right: 8px;
      margin-bottom: 8px;
    }
  `}
`;

export const StyledToggleButtonListItemWrapper = styled.div<{
  fullWidth?: boolean;
}>`
  ${({ fullWidth }) => fullWidth && css`
    display: flex;
    width: 100%;
  `}
`;
